/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2018 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
  "use strict";

  angular
    .module("ROGER")

    .controller("TradeInController", [
      "$scope",
      "$q",
      "$http",
      "$decisionBox",
      "$sessionStorage",
      "FileSaver",
      "Blob",
      "$user",
      "$oidc",
      "$translate",
      "$notifications",
      function (scope, $q, http, decisionBox, sessionStorage, FileSaver, Blob, user, oidc, translate, notifications) {
        scope.$storage = sessionStorage;
        scope.user = user;

        scope.filter = {
          dateFrom: null,
          dateTo: null,
          orderNumber: null,
          vin: null,
          showSent: null,
          showAccepted: null,
          showCancelled: null
        };

        scope.list = [];

        scope.$watch("$storage.retailer", function (newValue, oldValue) {
          if (oldValue.Id !== newValue.Id && newValue.Id > 0) {
            scope.refresh();
          }
        });

        function _loadTradeIns() {
          http
            .get("api/retailer/" + scope.$storage.retailer.Id + "/trade-in", {
              params: scope.filter,
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              }
            })
            .then(
              function (response) {
                scope.list = response.data;
              },
              function () {
                scope.list = [];
              }
            );
        }

        // Date pickers
        scope.dateFromOpen = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          scope.dateFromOpened = !scope.dateFromOpened;
        };

        scope.dateToOpen = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          scope.dateToOpened = !scope.dateToOpened;
        };

        // Sorting
        scope.sorting = function (orderName) {
          if (scope.list.orderName === orderName) {
            scope.list.orderDesc = !scope.list.orderDesc;
          } else {
            scope.list.orderName = orderName;
            scope.list.orderDesc = false;
          }
        };

        scope.sortingClass = function (orderName) {
          if (scope.list.orderName === orderName) {
            if (scope.list.orderDesc) {
              return "fa fa-caret-down";
            } else {
              return "fa fa-caret-up";
            }
          } else {
            return "";
          }
        };

        function _cancelTradeIn(tradeInId) {
          return http
            .put(
              "/api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/" +
              tradeInId +
              "/CAN",
              null,
              {
                headers: {
                  Authorization: oidc.current.token_type + " " + oidc.current.access_token
                }
              }
            );
        }

        scope.downloadAttachments = function (id) {
          return _downloadAttachments(id, scope.$storage.retailer.Id);
        }

        function _downloadAttachments(id, retailerId) {
          return http
            .get("/api/retailer/" + retailerId + "/trade-in/" + id + "/attachment/download", {
              responseType: 'arraybuffer',
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              },
              skipInterceptors: true
            })
            .then(function (response) {
              var contentDisposition = response.headers("content-disposition");
              var regex = /filename="*([^"].+[^"])"*;/g;
              var result = regex.exec(contentDisposition);
              var fileName = result[1];
              var data = new Blob([response.data], { type: response.headers("content-type") });
              FileSaver.saveAs(data, fileName);
            }, function (data) {
              translate(['TradeInAttachmentsDownloadError.Message', 'TradeInAttachmentsDownloadError.Name'])
                .then(function (translations) {
                  notifications.addError(
                    translations['TradeInAttachmentsDownloadError.Name'],
                    translations['TradeInAttachmentsDownloadError.Message']
                  );
                }, function () {
                  notifications.addError(
                    'Error',
                    'An error occured when downloading attachments'
                  );
                })
            });
        }

        scope.cancel = function (tradeInId) {
          return decisionBox
            .showConfirm(
              "CancelTradeInHeader",
              "CancelTradeInBody",
              "CancelTradeInConfirm",
              "CancelTradeInDecline"
            )
            .result.then(function () {
              return _cancelTradeIn(tradeInId);
            }, function (data) {
              return $q.reject();
            }).then(_loadTradeIns);
        };

        scope.refresh = function () {
          _loadTradeIns();
        };

        scope.getItemStripeClass = function (id) {
          if (id === 1 || id === 2 || id === 4) {
            return "bg-yellow";
          } else if (id === 3) {
            return "bg-green";
          } else if (id === 5) {
            return "bg-red";
          } else {
            return "";
          }
        };

        scope.nullDateFrom = function () {
          if (scope.filter.dateFrom) {
            scope.filter.dateFrom = null;
            return scope.refresh();
          }
        };

        scope.nullDateTo = function () {
          if (scope.filter.dateTo) {
            scope.filter.dateTo = null;
            return scope.refresh();
          }
        };

        if (scope.$storage.retailer !== null && scope.$storage.retailer.Id > 0) {
          scope.refresh();
        }
      }
    ]);
})();
